<section class="py-3 card card-div">

  <div class="container-fluid sticky-header">
    <div class="row d-flex justify-content-between align-items-center pb-2 g-3">
      <div class="col-12 col-md-8 sku-ledger-widget d-flex flex-column align-items-start">
        <span class="label-text text-muted mb-1">Performance insights</span>
        <div class="sku-badge px-3 px-md-4 py-2 mb-2 d-inline-block">
          <h2 class="sku-name fw-bold m-0 text-break">{{heading}}</h2>
        </div>
        <span class="footer-text text-muted small">Last {{selectedPeriod}} days — trends for this SKU</span>
      </div>

      <div class="col-12 col-md-4 d-flex align-items-center gap-2 justify-content-between justify-content-md-end flex-wrap">

        <div class="dropdown">
          <button class="btn dropdown-toggle period-btn py-2 px-3" type="button" id="periodDropdown"
            data-bs-toggle="dropdown" aria-expanded="false">
            Last {{selectedPeriod}} days
          </button>
          <ul class="dropdown-menu shadow-sm no-scrollbar" aria-labelledby="periodDropdown">
            @for (p of periods; track p) {
              <li>
                <a class="dropdown-item cursor-pointer small" (click)="setPeriod(p.value)">
                  {{p.label}}
                </a>
              </li>
            }
          </ul>
        </div>

        <button class="btn sku-btn py-2 px-3" (click)="clickViewSkuLedger()">
          View SKU Ledger
        </button>
      </div>
    </div>
  </div>

  <div class="container-fluid">

    <div class="row g-4 mt-1">

      <div class="col-12 col-xl-8 col-md-7 d-flex flex-column gap-4">
        <app-performance-sale-trends [selectedRange]="dateRange" [branchList]="branchList" [selectedTyre]="selectedTyre" [isBranchVisible]="isBranchVisible"></app-performance-sale-trends>
        <app-performance-price-trends [selectedRange]="dateRange" [branchList]="branchList" [selectedTyre]="selectedTyre" [isBranchVisible]="isBranchVisible"></app-performance-price-trends>
      </div>

      <div class="col-12 col-xl-4 col-md-5">
        <app-performance-highlights [selectedTyre]="selectedTyre" [selectedRange]="dateRange"></app-performance-highlights>
      </div>
    </div>

    <div class="row g-4 mt-2">
      <div class="col-12 col-md-6">
        <app-performance-closing-balance [selectedTyre]="selectedTyre" [selectedRange]="dateRange"></app-performance-closing-balance>
      </div>
      <div class="col-12 col-md-6">
        <app-performance-sale-value [selectedTyre]="selectedTyre" [selectedRange]="dateRange"></app-performance-sale-value>
      </div>
    </div>

    <div class="row mt-md-2 mt-1">
      <app-buyer-history [selectedTyre]="selectedTyre" [selectedRange]="dateRange"></app-buyer-history>
    </div>

    <div class="row mt-md-2 mt-1">
      <app-dealer-stop-buying [selectedTyre]="selectedTyre" ></app-dealer-stop-buying>
    </div>

  </div>
</section>